import { Component, Input, OnInit, output, viewChild } from '@angular/core';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { Day, Schedule } from '@domains';
import { select, Store } from '@ngrx/store';
import { CardComponent, Destructible, WeekPickerComponent } from '@rspl-ui';
import * as moment from 'moment';
import { takeUntil } from 'rxjs';

import { ScheduleConfig } from '../../components/schedule/schedule-config';
import { ScheduleFormComponent } from '../../components/schedule/schedule-form/schedule-form.component';
import { AppState } from '../../store/app-state.interface';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss'],
  imports: [CardComponent, MatTabGroup, MatTab, WeekPickerComponent, ScheduleFormComponent],
})
export class ScheduleComponent extends Destructible implements OnInit {
  @Input() config: ScheduleConfig;
  @Input() showMap = true;
  @Input() day: Day;
  @Input() isVisible = true;
  readonly weekPicker = viewChild(WeekPickerComponent);
  readonly schedule = viewChild(ScheduleFormComponent);
  isDefault = true;
  readonly scheduleSaved = output();
  updateSavedZones = output();
  defaultSchedule?: Schedule;

  constructor(private store: Store<AppState>) {
    super();
  }

  ngOnInit(): void {
    this.store.pipe(select(this.config.scheduleSelector), takeUntil(this.destroy$)).subscribe((schedule) => {
      if (this.isDefault && schedule?.length > 0 && !schedule[0].week && !schedule[0].year) {
        this.defaultSchedule = schedule[0];
      }
    });
  }

  selectedIndexChange(index: number): void {
    if (index === 0) {
      this.isDefault = true;
      this.schedule().fetchData();
    } else {
      this.isDefault = false;
      this.schedule().fetchData(moment().week(), moment().year());
    }
  }
}
